import axios from "axios";
import {MyFormValues} from "../components/Form/Form";

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
});

export const formAPI = {

    postFormData(data: MyFormValues, id: string) {
        const formData = new FormData();
        formData.append("purchase", `{"purchaseId": "${data.purchaseId}", "subjectPurchase": ${JSON.stringify(data.subjectPurchase)},
        "counterpart":{"name":${JSON.stringify(data.counterpart.name)},"email":"${data.counterpart.email}", "fio": "${data.counterpart.fio}",
        "phone": "${data.counterpart.phone}", "unp": "${data.counterpart.unp}"}}`);
        for (let i = 0; i < data.files.length; i++) {
            formData.append("file", data.files[i]);
        }
        return instance.put(`/purchase/${id}`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
    },

    getPurchaseData(id: string, hash: string) {
        return instance.post(`/purchase${id}`, {hash})
            .catch(error => console.log(error));
    }
};